/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type StorefrontFollowButton_seller$ref = any;
export type StorefrontFollowButton_seller = {
    readonly serviceId: string | null;
    readonly favoritesByUser?: ReadonlyArray<{
        readonly serviceId: string | null;
    } | null> | null;
    readonly " $refType": StorefrontFollowButton_seller$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "StorefrontFollowButton_seller",
        "type": "Seller",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String!"
            },
            {
                "kind": "RootArgument",
                "name": "hasUserId",
                "type": "Boolean"
            }
        ],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "favoritesByUser",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "userIds",
                                "variableName": "userId"
                            }
                        ],
                        "concreteType": "Favorite",
                        "plural": true,
                        "selections": [
                            (v0 /*: any*/)
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'f611bf7aab25f961ebcf84d31217e2d9';
export default node;
